import fetchLoyaltyAccountActivity from 'actions/loyalty/fetchLoyaltyAccountActivity'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyArray } from 'lib/array/arrayUtils'
import moment from 'moment'
import { useEffect } from 'react'

function useCurrentLoyaltyActivities(): [activities: Array<App.LoyaltyAccountActivity>, fetching: boolean, error: any] {
  const dispatch = useAppDispatch()

  const accountActivity = useAppSelector(state => state.loyalty.accountActivity)
  useEffect(() => {
    dispatch(fetchLoyaltyAccountActivity(
      moment().subtract(2, 'year').format(ISO_DATE_FORMAT),
      moment().add(1, 'year').format(ISO_DATE_FORMAT),
    ))
  }, [dispatch])

  return [
    accountActivity.data ?? EmptyArray,
    !!accountActivity.fetching,
    accountActivity.error,
  ]
}

export default useCurrentLoyaltyActivities
